import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { usePermissions } from '../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
  module?: string;
  action?: 'view' | 'create' | 'edit' | 'delete' | 'publish';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles, module, action }) => {
  const { auth, user } = useSelector((state: RootState) => state.User);
  const rehydrated = useSelector((state: any) => (state.User as any)?._persist?.rehydrated ?? true);
  const { hasPermission } = usePermissions();

  // Don't redirect while redux-persist is still restoring state from
  // localStorage — the store is empty until rehydration completes,
  // so `auth` is false even though the user IS logged in.
  if (!rehydrated) return null;

  if (!auth || !user) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (module && action && !hasPermission(module, action)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
